import React from 'react';
import styles from './PictureFrame.module.css';
import { Component } from 'react';
import noUser from '../../../assets/no_user.jpg';
import likeIcon from '../../../assets/like.png';
import noLikeIcon from '../../../assets/nolike.png';
import commentIcon from '../../../assets/comment.png';
import {connect} from 'react-redux';
import axios from 'axios';
import { Link } from 'react-router-dom';
import FollowList from '../FollowList/FollowList';

class PictureFrame extends Component {

    state = {
        isPostLiked: this.props.likes.indexOf(this.props.loginStatus.userId) > -1,
        likes: this.props.likes.length - 1,
        comments: this.props.comments.slice(1),
        followListModal: {
            isShow: false,
            name: 'Likes',
            isLike: true,
            followList: [],
            following: [],
            followClicked: []
        }
    }
    commentRef = React.createRef();
    componentDidMount() {
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    }

    componentWillUnmount() {
        document.getElementsByTagName('body')[0].style.overflow = '';
    }
    toggleFollowListModal = () => {
        this.setState({
            followListModal: {
                ...this.state.followListModal,
                isShow: !this.state.followListModal.isShow,
                followList: this.props.likes
            }
        })
    }
    like = () => {
        this.setState({
            isPostLiked: !this.state.isPostLiked, 
            likes: this.state.isPostLiked ? this.state.likes - 1 : this.state.likes + 1
        });
        axios.get('/users/'+this.props.userId+'.json?auth='+ this.props.loginStatus.authToken)
        .then(response=>{
            const userData = response.data;
            const likes = userData.posts[this.props.index].likes;
            const index = likes.indexOf(this.props.loginStatus.userId);
            if(index > -1){
                likes.splice(index, 1);
                userData.notifications.map((obj, index) => {
                    if(obj.userId === this.props.loginStatus.userId && obj.key === 'LIKE' && obj.url === this.props.url) {
                        userData.notifications.splice(index, 1);
                    }
                })
            } else {
                likes.push(this.props.loginStatus.userId);
                if(this.props.userId !== this.props.loginStatus.userId) {
                    userData.notifications.push({
                        key: 'LIKE',
                        name: this.props.userData.name,
                        isRead: false,
                        profilePic: this.props.userData.profilePic,
                        timeStamp: new Date(),
                        userId: this.props.loginStatus.userId,
                        url: this.props.url
                    });
                }
            } 
            
            axios.put('/users/'+this.props.userId+'.json?auth='+ 
            this.props.loginStatus.authToken, response.data)
            .then(res => {
                if(this.props.postIndex === undefined) return;
                const post = res.data.posts[this.props.index];
                post.postIndex = this.props.postIndex;
                post.index = this.props.index - 1;
                post.userId = this.props.userId;
                post.name = this.props.user.name;
                post.profilePic = this.props.user.profilePic;
                post.isVerified = this.props.user.isVerified;
                this.props.onResponse(post);
            })
            .catch(err=>console.log(err));       
        })
    }

    comment = () => {
        if(this.commentRef.current.value.trim() === '') return;
        const comment = {
            name: this.props.userData.name,
            userId: this.props.loginStatus.userId,
            comment: this.commentRef.current.value,
            timestamp: new Date()
        }

        axios.get('/users/'+this.props.userId+'.json?auth='+ this.props.loginStatus.authToken)
        .then(response=>{
            const userData = response.data;
            userData.posts[this.props.index].comments.push(comment);
            if(this.props.userId !== this.props.loginStatus.userId) {
                userData.notifications.push({
                    key: 'COMMENT',
                    name: this.props.userData.name,
                    isRead: false,
                    profilePic: this.props.userData.profilePic,
                    timeStamp: new Date(),
                    userId: this.props.loginStatus.userId,
                    url: this.props.url
                });
            }
            this.commentRef.current.value = '';
            this.setState({comments: [...this.state.comments, comment]});

            axios.put('/users/'+this.props.userId+'.json?auth='+ 
            this.props.loginStatus.authToken, response.data)
            .then(res => {
                if(this.props.postIndex === undefined) return;
                const post = res.data.posts[this.props.index];
                post.postIndex = this.props.postIndex;
                post.index = this.props.index - 1;
                post.userId = this.props.userId;
                post.name = this.props.user.name;
                post.profilePic = this.props.user.profilePic;
                post.isVerified = this.props.user.isVerified;
                this.props.onResponse(post);
            })
            .catch(err=>console.log(err));   
        })
    }

    getTimeStamp = (date) => {
        const _date = new Date(date);
        const milliseconds = new Date() - _date;
        const monts = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

        if((milliseconds/1000) < 60) return Math.floor(milliseconds/1000) + ' SECONDS AGO';
        else if((milliseconds/60000) < 60){
            const minutes = Math.floor(milliseconds/60000);
            return  minutes + (minutes > 1 ? ' MINUTES AGO' : ' MINUTE AGO');
        } 
        else if((milliseconds/3600000) <= 24) { 
            const hours = Math.floor(milliseconds/3600000);
            return hours + (hours > 1 ? ' HOURS AGO' : ' HOUR AGO');
        }
        else if((milliseconds/3600000/24) <= 7){
            const days = Math.floor(milliseconds/3600000/24);
            return days + (days > 1 ? ' DAYS AGO' : ' DAY AGO');
        } else {
            
            return _date.getDate() + ' ' + monts[_date.getMonth()];
        }
    }

    getDesc = (desc) => {
        const hashTags = [...desc.matchAll(/#\w+/g)];
        hashTags.map(tag=> {
            desc = desc.replace(tag[0], '<span style="color:#0065c8">'+tag[0]+'</span>');
        });
        desc = desc.replace(/\n/g,'<br />');
        desc = '<b>'+this.props.user?.name+'</b>&nbsp;' + desc;
        return desc;
    }
    render() {
        return(
            <div className={styles.main}>
                <div className={styles.modal}>
                    <div className={styles.header}>
                        <Link to={'/account/' + this.props.userId} style={{position:'relative'}}>
                            <img src={this.props.user ? this.props.user.profilePic : noUser} width="27" height="27" alt="profile" />
                            <div className={styles.cover}></div>
                        </Link>
                        <Link to={'/account/' + this.props.userId}><span style={{fontWeight: 600}}> {this.props.user?.name}</span></Link>
                       {this.props.user.isVerified ?
                            <span style={{marginLeft:'5px'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="16px" height="16px">
                            <polygon fill="#42a5f5" points="29.62,3 33.053,8.308 39.367,8.624 39.686,14.937 44.997,
                            18.367 42.116,23.995 45,29.62 39.692,33.053 39.376,39.367 33.063,39.686 29.633,44.997 24.005,
                            42.116 18.38,45 14.947,39.692 8.633,39.376 8.314,33.063 3.003,29.633 5.884,24.005 3,18.38 8.308,
                            14.947 8.624,8.633 14.937,8.314 18.367,3.003 23.995,5.884"/>
                            <polygon fill="#fff" points="21.396,31.255 14.899,24.76 17.021,22.639 21.428,27.046 30.996,
                            17.772 33.084,19.926"/>
                            </svg>
                            </span>
                            : null
                        }
                        <span className={styles.time}>{this.getTimeStamp(this.props.timestamp)}</span>
                        <button className={styles.close} onClick={this.props.close}>
                            <svg fill="grey"  height="24" viewBox="0 0 48 48" width="24">
                            <path  d="M41.1 9.1l-15 15L41 39c.6.6.6 1.5 0 2.1s-1.5.6-2.1 
                            0L24 26.1l-14.9 15c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l14.9-15-15-15c-.6-.6-.6-1.5 
                            0-2.1s1.5-.6 2.1 0l15 15 15-15c.6-.6 1.5-.6 2.1 0 .6.6.6 1.6 0 2.2z">
                            </path></svg>
                        </button>
                    </div>
                    <div className={styles.middle}>
                    <div className={styles.picture}>
                        <img src={this.props.url} alt="post" width="100%"/>
                        <div className={styles.cover}></div>
                    </div>
                    <div className={styles.action}>
                        <button style={{backgroundImage: this.state.isPostLiked?'url('+likeIcon+')':'url('+noLikeIcon+')'}}
                         onClick={this.like}></button>
                        <button style={{backgroundImage:'url('+commentIcon+')'}} 
                        onClick={()=>this.commentRef.current.focus()}></button>
                        {this.props.hasDelete?
                        <button className={styles.delete} onClick={()=>this.props.delete(this.props.url,this.props.index)}></button>
                        :null
                        }
                    </div>
                    <div className={styles.likes} onClick={this.toggleFollowListModal}
                    style={{display:this.state.likes ? '':'none'}}>
                        {this.state.likes} {this.state.likes === 1 ? 'Like':'Likes'}
                    </div>
                    <div className={styles.desc} dangerouslySetInnerHTML={this.props.desc !== 'NA' ? 
                    {__html: this.getDesc(this.props.desc)}: null}></div>
                    <div className={styles.comments}>
                        {this.state.comments.map(obj=>{
                            return <div key={obj.timestamp} className={styles.comment}>
                                 <img src={this.props.users[obj.userId] ? 
                                 this.props.users[obj.userId]?.profilePic : noUser} alt="dp" />
                                 <div style={{marginTop:'3px'}}>
                                    <Link to={'/account/'+ obj.userId}>
                                        {obj.name} &nbsp;
                                    </Link>
                                    <span>{obj.comment}</span>
                                 </div>
                            </div>
                        })
                        }       
                    </div>
                    </div>
                    <div className={styles.footer}>
                        <textarea placeholder="Add a comment..." ref={this.commentRef}></textarea>
                        <button onClick={this.comment}>Post</button>
                    </div>
                   
                </div>
                {this.state.followListModal.isShow ?
                <FollowList data={this.state.followListModal} close={this.toggleFollowListModal}/>
                :null
            }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        loginStatus: state.loginStatus,
        userData: state.userData
    }
}

export default connect(mapStateToProps)(PictureFrame);